import React from "react";
import { get } from "lodash";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const Feature = ({ icon, title, text, url_text, url: { url, target } }) => (
  <div className="col-md-4 mb-4 mb-2xl-4 pb-1 pb-2xl-1 features-content-column">
    <div className="py-md-4 py-2xl-4 py-2 px-md-4 px-2xl-4 px-2 position-relative feature-block-holder">
      {url && <PrismicLinkTag url={url} target={target} className="feature-block-link" />}
      <div className="d-flex justify-content-center feature-block-image-holder">
        <PrismicImgix
          alt={icon.alt}
          src={icon.url}
          className="img-responsive img-responsive-height"
          desktop="300px"
          mobile="375px"
          tablet="170px"
          largeDisplay="500px"
        />
      </div>
      <div className="mt-3 mt-2xl-3 font-weight-bold text-center text-theme-primary features-block-title">
        {textResolver(title)}
      </div>
      <div className="text-center features-content-block">
        <div className="mt-md-3 mt-2xl-3 mt-2 sns-h5 features-content-block-text">
          {textResolver(text)}
        </div>
        {url && (
          <div className="sns-h5 mt-2 mt-2xl-2 pt-1 pt-2xl-1 font-weight-bold program-link features-block-link">
            {textResolver(url_text)}
          </div>
        )}
      </div>
    </div>
  </div>
);

const Features = ({ doc }) => {
  const {
    title,
    description,
    url,
    url_text,
    cta_text = "",
    cta_link = {},
    internal_link_id,
    bg_color,
  } = doc?.primary || {};
  const { url: cta_url = "", target: cta_target = "" } = cta_link || {};
  const customClass = `${
    cta_url ? "" : "mt-md-4 mt-2xl-4 mt-3"
  } row justify-content-center features-content-blocks-row`;
  return (
    <div
      className="pt-md-3 pt-2xl-4 pt-5 pb-4 pb-md-0 features-three-block-section prismic-slice"
      style={{ background: bg_color }}
    >
      <div className="container pt-md-3 pt-2xl-5 how-it-work-section features-container container-width">
        {internal_link_id && (
          <span id={internal_link_id} className="scroll-point position-relative d-block" />
        )}
        {checkContentPresence(title) && (
          <div className="gift-methods text-center">
            <div className="sns-h2 navy-blue same-size-title features-three-block-section-title">
              {textResolver(title)}
            </div>
            <div className="pt-3 pt-2xl-4 sns-h5 ls-0 same-size-title features-three-block-section-description">
              {textResolver(description)}
            </div>
          </div>
        )}
        {cta_url && (
          <div className="other-custom-label">
            <div className="mt-md-4 mt-2xl-4 mb-2 mb-2xl-2 mt-2 col-12 mx-auto">
              <PrismicLinkTag
                urlText={cta_text}
                url={cta_url}
                target={cta_target}
                className="btn btn-block rounded text-white"
              />
            </div>
          </div>
        )}
        <div className={customClass}>
          {get(doc, "items")?.map((feature, idx) => (
            <Feature {...feature} key={`option-${idx}`} />
          ))}
        </div>
        {url?.url && (
          <div className="py-md-4 py-2xl-4 col-lg-4 col-12 mx-auto features-footer-link-row">
            <PrismicLinkTag
              urlText={url_text}
              url={url?.url}
              target={url?.target}
              className="button btn btn-block font-weight-bold button-marketing"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Features;
